import { render } from "./NewOrder.vue?vue&type=template&id=5e969425&scoped=true"
import script from "./NewOrder.vue?vue&type=script&lang=js"
export * from "./NewOrder.vue?vue&type=script&lang=js"

import "./NewOrder.vue?vue&type=style&index=0&id=5e969425&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e969425"]])

export default __exports__